<script setup>
import {ref, onMounted} from 'vue'

const props = defineProps({
    // No props defined in original, but available if needed
})

// --- State ---

const show = ref(false)

// --- Lifecycle ---

/**
 * We check localStorage to determine if the debug output should be rendered.
 * Using onMounted or immediate logic in setup works similarly to 'created'.
 */
const showOutput = localStorage.getItem('showOutput')
if (showOutput && parseInt(showOutput)) {
    show.value = true
}
</script>

<template>
    <pre v-if="show"><small><slot/></small></pre>
</template>

<style scoped>
/* Scoped styles preserved */
pre {
    background-color: #f8f9fa;
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    white-space: pre-wrap;
    word-wrap: break-word;
}
</style>